// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addTextWidget()\"> <span translate=\"ADD_TEXT_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-text-widget widget=\"$ctrl.getWidget()\"></gb-edit-text-widget> ";
// Exports
export default code;